import styled from 'styled-components';

export const SessionCard = styled.div<{$marginBottom: string, $disabled: boolean}>`
    width: 100%;
    height: 72px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 24px;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 8px;
    background-color: ${({ theme, $disabled }) => $disabled
    ? theme.colors.surface.high
    : theme.colors.pillbutton.surface};
    margin-top: 8px;
    position: relative;
    margin-bottom: ${({ $marginBottom }) => $marginBottom};

    p {
        color: ${({ theme }) => theme.colors.button.text.disabled};
        font-size: 12px;
    }
`;

export const MainText = styled.h2<{$disabled: boolean}>`
    font-family: 'MADE TOMMY';
    color: ${({ theme, $disabled }) => $disabled ? theme.colors.button.text.disabled : theme.colors.text.primary};
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ArrowRight = styled.img<{ $disabled: boolean }>`
    position: absolute;
    right: 24px;
    background-color: ${({ theme, $disabled }) =>
    $disabled ? theme.colors.button.surface.disabled : theme.colors.surface.low};
    padding: 12px;
    border-radius: 50%;
    right: 24px;
`;
